exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hol-wrapper {\n  padding: 50px;\n  max-width: 600px;\n  margin: 0 auto; }\n  .hol-wrapper img {\n    display: block;\n    width: 150px;\n    margin: 0 auto; }\n  .hol-wrapper .title {\n    text-align: center; }\n  .hol-wrapper .intro {\n    font-size: 1.35em; }\n  .hol-wrapper .success {\n    margin-top: 2em;\n    text-align: center; }\n  .hol-wrapper .err-text {\n    display: flex;\n    align-items: flex-start;\n    margin: 1.5em 0; }\n    .hol-wrapper .err-text p {\n      margin: 0 0 0 5px;\n      font-weight: 400; }\n", ""]);

// exports
